module.exports = __webpack_public_path__ + "assets/img/31-l.e7cfec3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/31-l.jpg
// module id = dwy0
// module chunks = 0